export default "__VITE_ASSET__DPKo9IpO__"